<template lang="pug">
  v-dialog(
      v-model="startPreQualFlow"
      max-width="500"
      persistent
  )
      v-card.py-5.px-2(
          align="center"
          id="prequalModal-card"
      )
          v-img(
              max-width="40%"
              :src="greensky.logoSvg"
              id="prequalModal-card-GSImage"
          )
          h2.ma-3 Prequalify For Your Loan

          div.mx-3.text-xs-left.modal(id="prequalModal-card-disclaimer")
              | Want to see if you prequalify without impacting your credit score?
              br
              | Prequalify with no impact to your credit! 

              v-img.ma-4(
                  :src="preQualSvg"
              )

              p.title #[strong Plan Details ]
              p #[strong Plan: {{ plan.planNumber }} ]
              p {{ plan.planDescription }}
          v-layout(column align-center )
              v-btn.mt-4(
                  color="primary"
                  @click="goToPreQualForm"
              ) Get Started

              v-btn.mt-2(
                   outline
                  color="primary"
                  @click="abandonPreQualFlow"
              ) No Thanks

</template>

<script>
import { greensky } from 'Helpers/lenders'
import { mapState }  from 'vuex'

export default {
  name: 'PreQualificationModal',
  props: {
      startPreQualFlow: {
          type: Boolean,
          default: false,
      },
  },
  data: () => ({
      greensky,
      preQualDisclaimer: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean non suscipit mauris. Etiam fringilla libero et lobortis tempor. 
      Donec laoreet urna id hendrerit sodales. Cras vel molestie turpis, id facilisis velit. Cras congue pretium odio, ac vulputate lorem sagittis vitae. 
      Sed euismod ultrices mi sed tristique. Suspendisse auctor diam a enim blandit, id rhoncus ligula faucibus. Aliquam fermentum finibus sagittis. 
      Etiam ac lacus in turpis lacinia ultricies mollis at arcu.`,
      preQualSvg: require('Assets/prequal_steps.svg')
  }),
  computed: {
      ...mapState({
      plan: state => state.loanApplication.loanPlan
      })
  },
  methods: {
      goToPreQualForm() {
          console.log('Pre Qual Form')
          this.$router.push({
              path: '/credit-application/form-page-one'
          })
      },
      abandonPreQualFlow(){
              this.$emit('abandonPreQualFlow')
      }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  p {
      margin: 0;
  }
}
</style>